import { useDispatch } from "react-redux"
import { setSettingsWindowVisible } from "../../../actions/userSettingsActions";
import { IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

const SettingsFormHeader = () => {
    const dispatch = useDispatch();

    const onClickClose = () => {
        dispatch(setSettingsWindowVisible(false));
    }

    return (
        <div className="d-flex flex-row jc-space-between ai-start">
            <Typography variant="h3">Settings</Typography>
            <IconButton onClick={onClickClose}>
                <Close />
            </IconButton>
        </div>
    )
}

export default SettingsFormHeader;